import type { MySpaceRulesOverview, SpaceRuleOverview, SpaceSendRuleType } from '@/types/spaces';

export const RULE_TYPE_LABELS: Record<SpaceSendRuleType, string> = {
  description: 'Descrição', merchant: 'Estabelecimento', category: 'Categoria', tag: 'Tag', recurring: 'Recorrência',
};

export function ruleLabel({ rule, valueLabel }: SpaceRuleOverview): string {
  const value = valueLabel?.trim();
  return `${RULE_TYPE_LABELS[rule.type]}: ${value ? `${rule.type === 'tag' ? '#' : ''}${value}` : 'indisponível'}`;
}

const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === 'object' && value !== null;

// The labels of the person's ENABLED rules for one space, in the API's order. The body is checked as far as it is
// read: anything of another shape (an older API, a proxy) yields no chips instead of a crash on the landing page.
export function ownRuleChips(data: unknown, spaceId: string): string[] {
  if (!isRecord(data) || !Array.isArray(data.spaces)) return [];
  const entry = data.spaces.find((item) => isRecord(item) && isRecord(item.space) && item.space.id === spaceId);
  if (!isRecord(entry) || !Array.isArray(entry.rules)) return [];
  return entry.rules.filter(isRuleOverview).filter(({ rule }) => rule.enabled).map(ruleLabel);
}

// `Object.hasOwn` coerces its key, so `['description']` would pass as 'description': the type is checked first.
function isRuleType(value: unknown): value is SpaceSendRuleType {
  return typeof value === 'string' && Object.hasOwn(RULE_TYPE_LABELS, value);
}

function isRuleOverview(item: unknown): item is SpaceRuleOverview {
  if (!isRecord(item) || !isRecord(item.rule)) return false;
  // `valueLabel` is always sent: null means the target is gone ("indisponível"), a missing field means another shape.
  const label = item.valueLabel;
  return typeof item.rule.id === 'string' && typeof item.rule.enabled === 'boolean' && isRuleType(item.rule.type)
    && (label === null || typeof label === 'string');
}

export function ruleWindow(start: string | null, end: string | null): string | null {
  const format = (date: string) => new Date(date).toLocaleDateString('pt-BR', { timeZone: 'UTC' });
  if (start && end) return `${format(start)} a ${format(end)}`;
  if (start) return `A partir de ${format(start)}`;
  if (end) return `Até ${format(end)}`;
  return null;
}

export function updateRuleEnabled(data: MySpaceRulesOverview, id: string, enabled: boolean): MySpaceRulesOverview {
  return { ...data, spaces: data.spaces.map((space) => ({ ...space,
    rules: space.rules.map((entry) => entry.rule.id === id ? { ...entry, rule: { ...entry.rule, enabled } } : entry),
  })) };
}
